import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Opens a Bootstrap modal on connect when openValue is true
// (e.g. after a failed clone re-renders the show page with errors).
export default class extends Controller {
  static values = { open: Boolean }

  connect() {
    if (!this.openValue) return

    Modal.getOrCreateInstance(this.element).show()
  }
}
